import { isAddressMatch } from 'src/public/components/online_ordering/addressUtils'
import { RangedCustomerAddress } from 'src/public/components/online_ordering/DeliveryContext'
import { CartDeliveryInfo } from 'src/public/components/online_ordering/FulfillmentContext'

/**
 * Utility function to filter customer addresses and separate them into in-range and out-of-range arrays
 * Filters out the session delivery address by both GUID and property address matching (required because of
 * cart response models inability to provide stable mapping identifiers)
 */
export const filterCustomerAddresses = (
  customerAddresses: RangedCustomerAddress[],
  sessionDeliveryInfo: CartDeliveryInfo | null | undefined
): [RangedCustomerAddress[], RangedCustomerAddress[]] => {
  const shouldFilterOutAddress = (
    customerAddress: RangedCustomerAddress
  ): boolean => {
    if (!sessionDeliveryInfo) {
      return false
    }

    return isAddressMatch(customerAddress, sessionDeliveryInfo)
  }

  const inRangeAddresses = customerAddresses.filter(
    (addr) => addr.inRangeOfRx && !shouldFilterOutAddress(addr)
  )

  const outOfRangeAddresses = customerAddresses.filter(
    (addr) => !addr.inRangeOfRx && !shouldFilterOutAddress(addr)
  )

  return [inRangeAddresses, outOfRangeAddresses]
}

/**
 * Utility function to check if an address is a saved address
 * Screens can use this instead of complex logic
 */
export const isSavedAddress = (address: CartDeliveryInfo | null): boolean => {
  return !!(address?.guid && address.guid.length > 0)
}
